//all OPPORTUNITIES
export const ALL_OPPORTUNITIES_REQUEST = 'ALL_OPPORTUNITIES_REQUEST';
export const ALL_OPPORTUNITIES_SUCCESS = 'ALL_OPPORTUNITIES_SUCCESS';
export const ALL_OPPORTUNITIES_ERROR = 'ALL_OPPORTUNITIES_ERROR';
export const CLEAR_ALL_OPPORTUNITIES = 'CLEAR_ALL_OPPORTUNITIES';
